import type React from "react";

export function AuthLayout({ children }: { children: React.ReactNode }) {
	return (
		<main className="flex min-h-dvh flex-col p-2">
			<div className="flex grow items-center justify-center p-6 lg:rounded-2xl lg:bg-base-200 lg:p-10 lg:shadow-xl lg:ring-1 lg:ring-base-content/5">
				{children}
			</div>
		</main>
	);
}
